import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  @Input() externLinks: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
  getYear(): number {
    return new Date().getFullYear();
  }
}
